import * as React from 'react';
import { useFragment } from 'react-relay';
import { quoteBlockFragment } from './QuoteBlock.relay';
import { quoteBlockClassName } from './lib/QuoteBlockStyles';
import { QuoteBorder } from './lib/QuoteBorder';
import type { QuoteBlockPropsType } from './types';

const QuoteBlock: React.FC<QuoteBlockPropsType> = ( props: QuoteBlockPropsType ) => {
    const contentBlock = useFragment( quoteBlockFragment, props.contentBlock );

    return (
        <div className={quoteBlockClassName}>
            <div className='quote-wrapper'>
                <QuoteBorder />
                <p className='quote-text'>{contentBlock.text}</p>
                <span className='quote-source'>{contentBlock.author}</span>
                <QuoteBorder closing />
            </div>
            <img className='icon' src={ process.env.HOST + contentBlock.iconUrl } />
        </div>
    );
};

export { QuoteBlock };
